import { stdObject } from "../../../data/types/stdObject";

export const deletePaymentRecord = (
  index: number,
  windowValues: stdObject,
  setWindowValues: any,
) => {
  let tempValues = windowValues;
  tempValues.changed = true;
  tempValues.records[index].delete = !tempValues.records[index].delete;
  tempValues.BAL =
    tempValues.info.TOT -
    tempValues.records
      .filter((e: stdObject) => !e.delete)
      .reduce((a: number, b: stdObject) => a + b.CANDIN, 0);
  setWindowValues({ ...tempValues });
};
